// Embossed official seal: concentric navy rings, curved verification text on a
// <textPath>, the iElect mark at the centre, and a success ✓ when verified.
// Pure SVG so it rasterises crisply into the PDF/PNG capture. Colours are
// hardcoded brand hex (navy #022745, green #059669) — html2canvas captures these
// reliably and the document is intentionally theme-independent.

import { IELECT_MARK_DATA_URL } from '../../../assets/images/ielect-mark-data';

const NAVY = '#022745';
const NAVY_SOFT = '#1e538f';
const GREEN = '#059669';

const Seal = ({ size = 108, verified = true }: { size?: number; verified?: boolean }) => (
	<svg
		className='completion-receipt__seal-svg'
		width={size}
		height={size}
		viewBox='0 0 120 120'
		role='img'
		aria-label={verified ? 'Official verified submission seal' : 'Submission seal'}
	>
		<defs>
			<path
				id='cr-seal-arc-top'
				d='M 18,60 A 42,42 0 0 1 102,60'
				fill='none'
			/>
			<path
				id='cr-seal-arc-bottom'
				d='M 22,60 A 38,38 0 0 0 98,60'
				fill='none'
			/>
			<radialGradient
				id='cr-seal-face'
				cx='42%'
				cy='34%'
				r='75%'
			>
				<stop
					offset='0%'
					stopColor='#ffffff'
				/>
				<stop
					offset='62%'
					stopColor='#f3f6fb'
				/>
				<stop
					offset='100%'
					stopColor='#e2e9f2'
				/>
			</radialGradient>
		</defs>

		{/* embossed face */}
		<circle
			cx='60'
			cy='60'
			r='56'
			fill='url(#cr-seal-face)'
		/>
		<circle
			cx='60'
			cy='60'
			r='55'
			fill='none'
			stroke={NAVY}
			strokeWidth='2'
		/>
		<circle
			cx='60'
			cy='60'
			r='47'
			fill='none'
			stroke={NAVY_SOFT}
			strokeWidth='1'
			strokeDasharray='1.5 3'
		/>

		{/* curved text band */}
		<text
			fill={NAVY}
			fontSize='8.2'
			fontWeight='700'
			letterSpacing='2.2'
		>
			<textPath
				href='#cr-seal-arc-top'
				startOffset='50%'
				textAnchor='middle'
			>
				VERIFIED SUBMISSION
			</textPath>
		</text>
		<text
			fill={NAVY_SOFT}
			fontSize='6.6'
			fontWeight='600'
			letterSpacing='3'
		>
			<textPath
				href='#cr-seal-arc-bottom'
				startOffset='50%'
				textAnchor='middle'
			>
				iELECT · ERMS
			</textPath>
		</text>

		{/* centre iElect mark — embedded, so the html2canvas capture never waits on a network image */}
		<image
			href={IELECT_MARK_DATA_URL}
			x='46'
			y='42'
			width='28'
			height='28'
		/>

		{/* verification check */}
		{verified ? (
			<g transform='translate(60 82)'>
				<circle
					r='11'
					fill={GREEN}
				/>
				<path
					d='M -5 0 L -1.5 3.6 L 5 -4'
					fill='none'
					stroke='#ffffff'
					strokeWidth='2.4'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
		) : null}
	</svg>
);

export default Seal;
